
    import './styles.scoped.css';
    export default {
  "content-header-sticky": "awsui_content-header-sticky_szx2o_g5idi_1",
  "content-header-refresh": "awsui_content-header-refresh_szx2o_g5idi_5"
};
  